import { render, staticRenderFns } from "./HistoryChecklist.vue?vue&type=template&id=10f4e88a&scoped=true&"
import script from "./HistoryChecklist.vue?vue&type=script&lang=ts&"
export * from "./HistoryChecklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f4e88a",
  null
  
)

export default component.exports